import { Group } from '@/components/_common';
import AntdFeatherIcon from '@/components/_common/AntdFeatherIcon';
import StatusTag from '@/components/_common/StatusTag';
import TagsAccountsPayableAndReceivableSelectModal from '@/components/Settings/Financial/TagsAccountsPayableAndReceivable/TagsAccountsPayableAndReceivableSelectModal';
import { useAccountReceivableIncludeTag } from '@/core/domain/financial/AccountReceivable/AccountReceivable.hooks';
import { useDisclosure } from '@/hooks';
import { useAccountReceivableContext } from '@/pages/FinancialPages/BillToReceivePage/ReleasesPage/ReleasesDetailPage';
import { truncateString } from '@/utils/functions/truncateString';
import { Button, Tooltip } from 'antd';
import { X } from 'react-feather';

export default function AccountReceivableHeaderTag() {
  const { accountReceivableHook, accountReceivable, currentInstallment } =
    useAccountReceivableContext();
  const [modalSelectTag, modalSelectTagActions] = useDisclosure();

  const installment =
    accountReceivable?.installmentReceivables[currentInstallment];
  const installmentTag = installment?.installmentTag;

  const includeTag = useAccountReceivableIncludeTag();

  async function handleComplementTag(installmentTagId?: number | null) {
    if (installment && accountReceivable) {
      await includeTag.mutateAsync({
        accountReceivableId: accountReceivable.id,
        installmentReceivableId: installment.id,
        installmentTagId,
      });
    }
  }

  return (
    <>
      {!!installmentTag ? (
        <Group gap={4}>
          <Tooltip title={installmentTag.name.toUpperCase() || ''}>
            <StatusTag
              size="lg"
              color={installmentTag.color}
              label={truncateString(installmentTag.name.toUpperCase(), 20)}
              onClick={modalSelectTagActions.open}
            />
          </Tooltip>

          <Button
            icon={<AntdFeatherIcon icon={<X cursor="pointer" />} size={14} />}
            size="small"
            onClick={() => handleComplementTag(null)}
            loading={includeTag.isLoading}
            disabled={accountReceivableHook.isFetching}
          />
        </Group>
      ) : (
        <StatusTag
          color="default"
          size="lg"
          className="card-select-tag"
          label="Selecionar Etiqueta"
          onClick={modalSelectTagActions.open}
          disabled={includeTag.isLoading || accountReceivableHook.isFetching}
        />
      )}

      <TagsAccountsPayableAndReceivableSelectModal
        onCancel={modalSelectTagActions.close}
        open={modalSelectTag}
        onCallback={handleComplementTag}
        confirmLoading={includeTag.isLoading}
      />
    </>
  );
}
